import React, {useContext, useState, useEffect} from "react";
import styled from "styled-components";
import tw from "twin.macro";
import {AppContext} from "../App";

const LetterStyle = styled.div`

  ${tw`
    flex
    items-center
    justify-center
 
    `}
`

const LetterContainer = styled.div`
  margin: 2px;
  ${tw`
    w-[2.5rem]
    h-[2.5rem]
    flex
    border-gray-700
    rounded-lg
    text-5xl
    uppercase
    font-extrabold
    justify-center
    items-center
    text-center
    
    sm:border-2
    sm:border-gray-700
    sm:text-7xl
    sm:w-[4rem]
    sm:h-[4rem]
    md:w-[5rem]
    md:h-[5rem]
    md:text-7xl
    
    lg:h-16
    lg:w-16
    xl:h-20
    xl:w-20
    xl:text-7xl
    `}
`

export default function Letter({letterPos, attemptVal}) {
    const {
        board,
        correctWord,
        currAttempt,
        setDisabledLetters,
        setAlmostLetters,
        setCorrectLetters,
        setErrorLetters,
        setBoard
    } = useContext(AppContext)
    const letter = board[attemptVal][letterPos]

    const correct = correctWord[letterPos] === letter

    const almost = !correct && letter !== "" && correctWord.includes(letter)

    const error = !correct && letter !== ""

    const letterState = currAttempt.attempt > attemptVal &&
        (correct ? "bg-green-500" : almost ? "bg-yellow-500" : error ? "bg-gray-600" : "bg-gray-500")

    useEffect(() => {
        if (letter !== "" && !correct && !almost) {
            setErrorLetters(prev => [...prev, letter])
        } else if (letter !== "" && !correct && almost) {
            setAlmostLetters(prev => [...prev, letter])
        } else if (letter !== "" && correct ){
            setCorrectLetters(prev => [...prev, letter])
        } else {
            setBoard( prev => [...board])
        }
    }, [currAttempt.attempt])

    return (
        <>
            <LetterStyle>
                <LetterContainer className={letterState || "bg-gray-500"}>
                    {letter}
                </LetterContainer>
            </LetterStyle>
        </>
    )
}


/*

 */
